// extracted by mini-css-extract-plugin
export default {"form":"index_form__zOzNE","error":"index_error__IaCJr","checkbox":"index_checkbox__nJzjn"};